var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"noprint":""}},[_c('buttonRadar',{attrs:{"classbutton":_vm.$store.state.isActiveHome ? 'register register--isActiveHome' : 'register',"iconic":"register","refto":"/signup#signup"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }